var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62253 1.0722C4.10238 0.37958 5.12636 0.379581 5.60622 1.0722L9.01138 5.98713C9.5658 6.78737 8.99307 7.88093 8.01954 7.88093H1.2092C0.235668 7.88093 -0.337062 6.78737 0.21736 5.98713L3.62253 1.0722ZM4.84326 1.60079C4.73252 1.44095 4.49622 1.44095 4.38548 1.60079L0.980318 6.51572C0.852373 6.70039 0.984544 6.95275 1.2092 6.95275H8.01954C8.2442 6.95275 8.37637 6.70039 8.24842 6.51572L4.84326 1.60079Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60575 16.4024C5.12589 17.095 4.10191 17.095 3.62206 16.4024L0.216891 11.4875C-0.337531 10.6872 0.235202 9.59368 1.20874 9.59368L8.01907 9.59368C8.9926 9.59368 9.56533 10.6872 9.01091 11.4875L5.60575 16.4024ZM4.38501 15.8738C4.49575 16.0337 4.73205 16.0337 4.84279 15.8738L8.24795 10.9589C8.3759 10.7742 8.24373 10.5219 8.01907 10.5219L1.20874 10.5219C0.984075 10.5219 0.851905 10.7742 0.979849 10.9589L4.38501 15.8738Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.4b202608e0b2da08a830dfc2dba72491.svg";
export { ForwardRef as ReactComponent };